export const editableFieldsList = ['boughtClicks', 'soldClicks'];
export const fieldNameDropDown = ['adGroupName'];
export const dropDownMenuUrls = [
  {
  'label': 'Selling Partner Report',
  'link': 'SellingPartnersReport',
  'paramsList': [
    'siteId',
    'sourceId',
    'campaignName',
    'adGroupName'
  ],
  'commonParamsList': [
    'dateStartB',
    'dateEndB',
    'datesComparison',
    'groupByDate'
  ]
},
  {
    'label': 'Hourly',
    'link': ''
  },
  {
    'label': 'History',
    'link': ''
  },
  {
    'label': 'Landing Page',
    'link': ''
  },
  {
    'label': 'Target Link',
    'link': ''
  },
  {
    'label': 'Keyword Rotation',
    'link': ''
  },
  {
    'label': 'Advertisers',
    'link': ''
  },
  {
    'label': 'Search Query Report',
    'link': ''
  }];
export const reportColumnsDefinitions = [
  {
    label: 'Date',
    field: 'date',
    sign: null,
    width: '120px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'string'
    },
    checked: false,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    defaultSorting: false,
    isCompareColumn: false,
  },
  {
    label: 'Site Name',
    field: 'siteName',
    sign: null,
    width: '120px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'string'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    defaultSorting: false,
    defaultSortingOrder: 'ASC',
    isCompareColumn: false,
  },
  {
    label: 'Source',
    field: 'sourceName',
    sign: null,
    width: '100px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'string'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    isCompareColumn: false,
  },
  {
    label: 'Partner',
    field: 'partnerName',
    sign: null,
    width: '100px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'string'
    },
    checked: false,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    isCompareColumn: false,
  },
  {
    label: 'Device',
    field: 'deviceName',
    sign: null,
    width: '100px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'string'
    },
    checked: false,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    isCompareColumn: false,
  },
  {
    label: 'Page',
    field: 'pageName',
    sign: null,
    width: '100px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'string'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    isCompareColumn: false,
  },
  {
    label: '2nd Search',
    field: 'secondSearch',
    sign: null,
    width: '100px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'boolean'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    isCompareColumn: false,
  },
  {
    label: 'Bought',
    field: 'boughtClicks',
    sign: null,
    width: '100px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'integer'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'Zone',
    field: 'zoneName',
    sign: null,
    width: '100px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'string'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    isCompareColumn: false,
  },
  {
    label: 'Block',
    field: 'blockName',
    sign: null,
    width: '100px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'string'
    },
    checked: false,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    isCompareColumn: false,
  },
  {
    label: 'Outbound',
    field: 'outboundClicks',
    sign: null,
    width: '100px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'integer'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'Revenue',
    field: 'revenue',
    sign: '',
    width: '100px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'float',
      precision: 2
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'RPC',
    field: 'rpc',
    sign: '',
    width: '100px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'float',
      precision: 2
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'CTR',
    field: 'opCtr',
    sign: '',
    width: '100px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'percentage',
      precision: 2
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'RPS',
    field: 'rps',
    sign: '',
    width: '100px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'float',
      precision: 2
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
];



// WEBPACK FOOTER //
// ./src/configs/revenue-partners-report-config.js